var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":this.canvasSize.width,"height":_vm.canvasSize.height,"viewBox":_vm.canvasSize.viewBox,"fill":"none","xmlns":"http://www.w3.org/2000/svg","title":_vm.title},domProps:{"innerHTML":_vm._s(_vm.lightColorFilter+_vm.icon)}})
}
var staticRenderFns = []

export { render, staticRenderFns }